export default __webpack_public_path__ + "static/media/es.a7b97553.png";